// replay.ts — scriptable, seeded replay. `?replay=demo` auto-runs a fixed sequence of words at
// fixed offsets, so combined with `?seed=` the same run reproduces identically every time — the
// precondition for capturing the same moment before/after a feel.json change (JUICE-RIG §5).
//
// This is NOT gameplay: it just feeds words into the same submit path a human would type, so the
// juice rig can be driven headlessly. Scripts are plain data; add your own below.

export interface ReplayStep {
  atMs: number;
  word: string;
}

export const SCRIPTS: Record<string, ReplayStep[]> = {
  // A climbing chain — short words then a long one, to show the pitch ladder + cascade at its peak.
  demo: [
    { atMs: 400, word: "note" },
    { atMs: 900, word: "filed" },
    { atMs: 1400, word: "duly" },
    { atMs: 1900, word: "pending" },
    { atMs: 2500, word: "bureaucratic" },
    { atMs: 3300, word: "zqxjk" }, // a reject, to show the invalid path
    { atMs: 3800, word: "ass" }, // an LDNOOBW-flagged word, to show the contempt path
  ],
};

/** If `?replay=<name>` is present, schedule its steps against `submit`. Returns true if it ran. */
export function maybeRunReplay(submit: (word: string) => void): boolean {
  const name = new URLSearchParams(location.search).get("replay");
  if (!name) return false;
  const script = SCRIPTS[name];
  if (!script) {
    console.warn(`[replay] no script named "${name}" — known: ${Object.keys(SCRIPTS).join(", ")}`);
    return false;
  }
  console.log(`[replay] running "${name}" (${script.length} steps)`);
  for (const step of script) {
    window.setTimeout(() => submit(step.word), step.atMs);
  }
  return true;
}
